import * as swcHelpers from '@swc/helpers';
import { LineItemModels } from '@grandvisionhq/lib-visuals';
import { getLocalizedString, isNil } from '@grandvisionhq/utils';
import { PrescriptionType } from '../../../models/line-item/prescription-glasses.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemAvailability } from '../../../utils/get-line-item-availability.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/get-failure-error-codes.js';
import { toBaseLineItem } from './base-line-item.js';
import { getProductA11yLabel } from './utils/get-product-a11y-label.js';
import { mapBundleChildLineItems } from './utils/map-bundle-child-line-items.js';
import { getLineItemProduct } from './utils/get-line-item-product.js';

function toLens(lens) {
    const { pupillaryDistance , power , cylinder , axis , addition  } = lens;
    return swcHelpers.objectSpread({}, !isNil(pupillaryDistance) ? {
        pupillaryDistance: pupillaryDistance.toString()
    } : null, !isNil(power) ? {
        power: power.toString()
    } : null, !isNil(cylinder) ? {
        cylinder: cylinder.toString()
    } : null, !isNil(axis) ? {
        axis: axis.toString()
    } : null, !isNil(addition) ? {
        addition: addition.toString()
    } : null);
}
function getPrescription(typeDetails) {
    var ref, ref1, ref2, ref3;
    const hasLeftLensPupillaryDistance = Boolean((ref = typeDetails.newPrescription) === null || ref === void 0 ? void 0 : ref.leftLens.pupillaryDistance);
    const hasRightLensPupillaryDistance = Boolean((ref1 = typeDetails.newPrescription) === null || ref1 === void 0 ? void 0 : ref1.rightLens.pupillaryDistance);
    const hasPupillaryDistanceFile = Boolean(typeDetails.pupillaryDistanceFile);
    const hasLeftAndRightLens = Boolean((ref2 = typeDetails.newPrescription) === null || ref2 === void 0 ? void 0 : ref2.leftLens) && Boolean((ref3 = typeDetails.newPrescription) === null || ref3 === void 0 ? void 0 : ref3.rightLens);
    const hasLeftAndRightPupillaryDistance = hasLeftLensPupillaryDistance && hasRightLensPupillaryDistance;
    if (typeDetails.newPrescription && !typeDetails.isOCRPrescription && typeDetails.prescriptionFile && hasLeftAndRightLens && (hasPupillaryDistanceFile && !hasLeftAndRightPupillaryDistance || !hasPupillaryDistanceFile && hasLeftAndRightPupillaryDistance)) {
        var ref4, ref5, ref6;
        return swcHelpers.objectSpread({
            type: PrescriptionType.PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: (ref4 = typeDetails.pupillaryDistanceFile) === null || ref4 === void 0 ? void 0 : ref4.fileName
        }, ((ref5 = typeDetails.newPrescription) === null || ref5 === void 0 ? void 0 : ref5.leftLens) && {
            leftEye: toLens(typeDetails.newPrescription.leftLens)
        }, ((ref6 = typeDetails.newPrescription) === null || ref6 === void 0 ? void 0 : ref6.rightLens) && {
            rightEye: toLens(typeDetails.newPrescription.rightLens)
        });
    }
    if (typeDetails.isOCRPrescription && typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: LineItemModels.PrescriptionType.OCR_PRESCRIPTION,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    } else if (typeDetails.newPrescription) {
        return {
            type: LineItemModels.PrescriptionType.NEW_PRESCRIPTION,
            leftEye: toLens(typeDetails.newPrescription.leftLens),
            rightEye: toLens(typeDetails.newPrescription.rightLens)
        };
    } else if (typeDetails.isEmailPrescription) {
        return {
            type: LineItemModels.PrescriptionType.EMAIL_PRESCRIPTION
        };
    } else if (typeDetails.isExistingCustomer) {
        return {
            type: LineItemModels.PrescriptionType.EXISTING_CUSTOMER
        };
    } else if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: LineItemModels.PrescriptionType.PRESCRIPTION_FILE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    throw new Error('Missing prescription details in visual line item mapper');
}
/*
  Glasses with prescription
*/ const toGlassesBundleCartLineItem = (lineItem, typeDetails, intl, settings, apiUrl)=>{
    var ref;
    const product = getLineItemProduct(lineItem);
    const variant = product.masterData.current.variant;
    const imageUrl = getLineItemImageUrl(variant);
    const packageNames = lineItem.bundleLineItems.reduce((subtitle, childLineItem)=>{
        if (childLineItem.isMainBundleLineItem) {
            return subtitle;
        }
        return `${subtitle}${getLocalizedString(childLineItem.legacyProduct.masterData.current.name, intl.locale)}, `;
    }, '').slice(0, -2);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, settings, intl), {
        imageUrl,
        subProductType: product.productType,
        type: 'GLASSES_BUNDLE',
        productType: 'prescription-glasses',
        title: `${getAttribute(variant, 'brand')} ${getAttribute(variant, 'brandModel')}`,
        subtitle: packageNames,
        altText: getProductA11yLabel(lineItem, intl),
        prescription: getPrescription(typeDetails),
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    }, variant.availability ? {
        availability: getLineItemAvailability(variant.availability)
    } : {}, {
        quoteConfig: (lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.quote) === null || ref === void 0 ? void 0 : ref.quoteToken) ? {
            quoteUrl: `${apiUrl}/quotes/${lineItem.quote.quoteToken}`,
            showQuoteLink: Boolean(settings.showQuoteLink)
        } : undefined
    });
};

export { toGlassesBundleCartLineItem };
//# sourceMappingURL=glasses-bundle-line-item.js.map
